export const CUSTOMTABLESETTING = 'custom_table_setting'
